import { NgModule } from '@angular/core';

import { ToUserNamePipe } from './to-user-name.pipe';

@NgModule({
    imports: [
    ],
    exports: [ToUserNamePipe],
    declarations: [ToUserNamePipe],
    providers: [],
})
export class ToUserNameModule { }
